export default `float s=2., e;
    for(int j=0;++j<8;s*=e=2./clamp(dot(p,p),.4,1.),p=abs(p)*e-vec3(2.0,1.0,.7));
    return length(p)/s;
  }`